import { render } from "./ClientsInsightComponent.vue?vue&type=template&id=920a7666&scoped=true"
import script from "./ClientsInsightComponent.vue?vue&type=script&lang=js"
export * from "./ClientsInsightComponent.vue?vue&type=script&lang=js"

import "./ClientsInsightComponent.vue?vue&type=style&index=0&id=920a7666&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-920a7666"]])

export default __exports__